import { createActionCreator } from "common/ReduxUtils";
import { PrepActionTypes } from "prep/store/PrepActionTypes";
import { FloorLoadedContainerDetail } from "@deliverr/prep-service-client";

export const setFCLContainerDetails = createActionCreator<FloorLoadedContainerDetail | undefined>(
  PrepActionTypes.SET_FLOOR_LOADED_CONTAINER_DETAILS,
  "floorLoadedContainerDetails"
);
